<template>
  <nav
    class="pagination"
    :class="{ dark, light }"
    role="navigation"
    aria-label="pagination"
    v-if="pageable"
  >
    <a
      class="pagination-previous"
      @click="changePage(pageable.page - 1)"
      :disabled="pageable.page <= 1"
      v-if="buttons"
    >
      <icon name="fa-chevron-left" />
    </a>
    <a
      class="pagination-next"
      @click="changePage(pageable.page + 1)"
      :disabled="pageable.page >= pageable.totalPages"
      v-if="buttons"
    >
      <icon name="fa-chevron-right" />
    </a>
    <ul class="pagination-list">
      <li v-for="(page, index) in pages" :key="index">
        <a
          v-if="isNotEllipsis(page)"
          class="pagination-link"
          :class="{ 'is-current': page === pageable.page }"
          :aria-label="
            page === pageable.page ? `Strona ${page}` : `Idź do strony ${page}`
          "
          aria-current="page"
          @click="changePage(page)"
          >{{ page }}</a
        >
        <span class="pagination-ellipsis" v-else>&hellip;</span>
      </li>
    </ul>
  </nav>
</template>

<script>
import { Icon } from "%helpers";
import { paginate, ELLIPSIS } from "%utils/pagination";

export default {
  name: "pagination",

  components: {
    Icon
  },

  props: {
    delta: {
      type: Number,
      default: 3
    },
    pageable: Object,
    dark: Boolean,
    light: Boolean,
    buttons: Boolean
  },

  computed: {
    pages() {
      return (
        this.pageable &&
        paginate(
          this.pageable.page || this.pageable.number,
          this.pageable.totalPages,
          this.delta
        )
      );
    }
  },

  methods: {
    isNotEllipsis(page) {
      return page !== ELLIPSIS;
    },

    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.pageable.totalPages) {
        this.$emit("change-page", newPage);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  &.dark {
    .pagination-link {
      border-color: $grey-dark;
      color: $grey-light;

      &:hover {
        border-color: $grey;
        color: $grey-lighter;
      }

      &.is-current {
        background: $link;
        border-color: $link;
        color: $white-ter;
      }
    }

    .pagination-previous,
    .pagination-next {
      border-color: $grey-dark;
      color: $grey-light;

      &:hover {
        border-color: $grey;
        color: $grey-lighter;
      }
    }

    [disabled] {
      background: $grey-dark;

      &:hover {
        border-color: $grey-dark;
        color: $grey-light;
      }
    }
  }

  &.light {
    .pagination-link {
      border-color: $grey-lighter;
      color: $grey-lighter;

      &:hover {
        border-color: $white;
        color: $white;
        background: transparentize($white, 0.9);
      }

      &.is-current {
        background: $white;
        border-color: $white;
        color: $grey-dark;
      }
    }

    .pagination-previous,
    .pagination-next {
      border-color: $grey-lighter;
      color: $grey-lighter;

      &:hover {
        border-color: $white;
        color: $white;
        background: transparentize($white, 0.9);
      }
    }

    [disabled] {
      $background: transparentize($white, 0.9);
      $color: transparentize($white, 0.6);
      background: $background;
      border-color: transparent;
      color: $color;

      &:hover {
        background: $background;
        border-color: transparent;
        color: $color;
      }
    }
  }
}
</style>
